<template>
  <BaseDataIterator ref="dataList" :service="fetchData">
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #header>
          <CustomerListHeader />
        </template>

        <template #default="{ item }">
          <CustomerListItem :customer="item" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { googleAdsCustomersClient } from '@/api/clients/admin';
import CustomerListHeader from './CustomerListHeader.vue';
import CustomerListItem from './CustomerListItem.vue';

export default {
  components: {
    CustomerListHeader,
    CustomerListItem,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    async fetchData(params = {}) {
      try {
        const response = await googleAdsCustomersClient.list({
          ...params,
          include: 'gaCampaignsCount',
        });

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
